import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { AuditState } from './audit.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([AuditState])],
  declarations: []
})
export class AuditStoreModule {}
